import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import type { ReactNode } from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  wide?: boolean
}

/**
 * All modals render as dark frosted glass. The panel carries the `dark` class, which
 * (via index.css) flips the semantic color tokens to the dark palette for the whole
 * subtree — so every modal's existing `text-text-*` / `bg-surface-*` / `border-*`
 * classes render light-on-dark automatically, no per-modal restyling. The panel's own
 * background is an explicit dark hex (token-independent) so the glass stays dark.
 */
export function Modal({ open, onClose, title, children, wide }: ModalProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/60 backdrop-blur-md transition-opacity duration-200 data-closed:opacity-0"
      />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className={`dark w-full rounded-2xl ${wide ? 'max-w-4xl' : 'max-w-md'} p-6 bg-[#0D1117]/85 backdrop-blur-2xl border border-white/10 ring-1 ring-white/5 shadow-2xl transition-all duration-200 data-closed:scale-95 data-closed:opacity-0`}
        >
          <DialogTitle className="text-lg font-semibold text-text-primary mb-5">
            {title}
          </DialogTitle>
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
